var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.params)?_c('div',{staticClass:"container"},[_c('span',{staticClass:"wrapper"},[_c('CheckBox',{attrs:{"checked":_vm.value},on:{"onChange":_vm.onChange}},[_vm._v("表示")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }